import { Injectable, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ActivityEditDialogData, ActivityWithTime, TripDay } from '../../../../../models';
import { ConfirmationDialogComponent } from '../../../../shared/confirmation-dialog/confirmation-dialog.component';
import { isActivityWithTimeOverlapping } from '../../../../shared/utils/activity-utils';

/**
 * 
 * A base class for all the activities dialog component.
 * 
 * Provides reusable overlap-check logic for activity edit dialogs so each dialog
 * can focus on its specific form concerns.
 */
@Injectable()
export abstract class ActivityEditDialogBase<T extends ActivityWithTime> implements OnDestroy {

  public activityEditIndex?: number;
  public currentDay!: TripDay;
  protected subscriptions: Subscription[] = [];

  protected constructor(
    protected dialogRef: MatDialogRef<unknown>,
    protected confirmationDialog: MatDialog,
    protected translateService: TranslateService,
    protected data: ActivityEditDialogData
  ) {
    this.activityEditIndex = data.activityEditIndex;
    this.currentDay = data.currentDay;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  protected confirmAndCloseDialog(activity: T): void {
    if (isActivityWithTimeOverlapping(activity, this.currentDay, this.activityEditIndex)) {
      const message = this.translateService.instant('trips.activity-time-conflict');
      const dialogRef = this.confirmationDialog.open(ConfirmationDialogComponent, {
        width: '300px',
        data: { message }
      });

      this.subscriptions.push(dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.dialogRef.close(activity);
        }
      }));
      return;
    }

    this.dialogRef.close(activity);
  }
}
